<script>
import { EmployeeImportFileStatus, getEmployeeImportFileStatus } from '@/utils/employee-import'

export default {
    props: {
        employeeImportFile: Object,
    },

    computed: {
        /**
         * Get the status badge style and label for the employee import file.
         */
        status() {
            switch (getEmployeeImportFileStatus(this.employeeImportFile)) {
                case EmployeeImportFileStatus.VALIDATION_FAILED:
                    return {
                        class: 'badge-danger',
                        label: Lang.get('employerdashboard::pages/employees-import/index.employee_import_file_statuses.validation_failed'),
                    }
                case EmployeeImportFileStatus.WAITING_FOR_APPROVAL:
                    return {
                        class: 'badge-info',
                        label: Lang.get('employerdashboard::pages/employees-import/index.employee_import_file_statuses.waiting_for_approval'),
                    }
                case EmployeeImportFileStatus.PROCESSING_FAILED:
                    return {
                        class: 'badge-danger',
                        label: Lang.get('employerdashboard::pages/employees-import/index.employee_import_file_statuses.processing_failed'),
                    }
                case EmployeeImportFileStatus.PROCESSING_SUCCESSFUL:
                    return {
                        class: 'badge-success',
                        label: Lang.get('employerdashboard::pages/employees-import/index.employee_import_file_statuses.processing_successful'),
                    }
                case EmployeeImportFileStatus.IN_PROGRESS:
                    return {
                        class: 'badge-info',
                        label: Lang.get('employerdashboard::pages/employees-import/index.employee_import_file_statuses.in_progress'),
                    }
            }
        },
    },
}
</script>

<template>
    <span
        class="badge font-poppins font-size-14 font-weight-semibold"
        :class="status.class">
        {{ status.label }}
    </span>
</template>

<style scoped>

</style>
